import { useBusinessModelSelector } from "@redux/reducers/deal";
import { getIsB2BSelected } from "@shared/v2/lib/getIsB2BSelected";

export const useIsB2BSelected = () => {
  const selectedBusinessModel = useBusinessModelSelector();

  return getIsB2BSelected(selectedBusinessModel);
};
